import { render, staticRenderFns } from "./PointWriteDefaultLayout.vue?vue&type=template&id=40b62622&scoped=true"
import script from "./PointWriteDefaultLayout.vue?vue&type=script&lang=js"
export * from "./PointWriteDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b62622",
  null
  
)

export default component.exports